import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { AnalyticsInstance } from '@ts/utils/analytics';
import * as S from './styles';

import Navbar from './Navbar';
import Carousel from './Carousel';
import SearchSelector from './SearchSelector';
import DateRangeSelector from './DateRangeSelector';

function Header({
    cartItems,
    destinations,
    forceCarousel,
    forceSimplify,
    forceSimplifyMobile,
    images,
    navStatic,
    onSearchSubmit,
    onSelectSearchDate,
    onSelectSearchDestination,
    openNavigation,
    searchDateFrom,
    searchDateTo,
    searchDestination,
    searchDestinationCategory,
    subtitle,
    title,
    wishList,
    checkoutPosition,
}) {
    const [scrollY, setScrollY] = React.useState('less');

    useEffect(() => {
        if (window.scrollY >= 350 && scrollY !== 'more') {
            setScrollY('more');
        }
        const onScroll = () => {
            if (window.scrollY >= 350 && scrollY !== 'more') {
                setScrollY('more');
            }
            if (window.scrollY < 350 && scrollY !== 'less') {
                setScrollY('less');
            }
        };
        document.addEventListener('scroll', onScroll);
        return () => {
            document.removeEventListener('scroll', onScroll);
        };
    }, [scrollY]);

    const onClickSearch = React.useCallback(() => {
        if (onSearchSubmit) {
            onSearchSubmit();
        }

        AnalyticsInstance.navigation.clickedSearchButton({
            destination: searchDestination,
            category: searchDestinationCategory,
        });
    }, [onSearchSubmit, searchDestination, searchDestinationCategory]);

    const carousel = forceCarousel ? forceCarousel : !!(images && Array.isArray(images));
    const fixed = navStatic ? false : true;
    const transparent = carousel ? scrollY === 'less' || navStatic : navStatic ? false : !fixed;

    const searchSelector = (
        <SearchSelector
            destination={searchDestination}
            destinationCategory={searchDestinationCategory}
            destinations={destinations}
            onSelect={onSelectSearchDestination}
        />
    );

    const dateRangeSelector = (
        <DateRangeSelector
            onSelect={onSelectSearchDate}
            dateFrom={searchDateFrom}
            dateTo={searchDateTo}
        />
    );

    return (
        <S.Header
            transparent={transparent}
            fixed={fixed}
            forceSimplifyMobile={forceSimplifyMobile}
            forceSimplify={forceSimplify}
            data-test-id="header"
        >
            <Navbar
                forceSimplify={forceSimplify}
                wishList={wishList}
                cartItems={cartItems}
                checkoutPosition={checkoutPosition}
                openNavigation={openNavigation}
                transparent={transparent}
            />
            <React.Fragment>{!carousel && fixed && <S.HeightLayer />}</React.Fragment>
            <S.SectionSearch data-test-id="section-search">
                <S.SectionSearchInner>
                    <React.Fragment>{searchSelector}</React.Fragment>
                    <React.Fragment>{dateRangeSelector}</React.Fragment>

                    <S.GoButton
                        data-test-id="go-button"
                        disabled={!searchDestination}
                        onClick={onClickSearch}
                    >
                        Go
                    </S.GoButton>
                </S.SectionSearchInner>
            </S.SectionSearch>
            <React.Fragment key="Carousel">
                {carousel && (
                    <S.SectionCarousel data-test-id="section-carousel">
                        <Carousel images={images}>
                            <S.Section data-test-id="titles">
                                <React.Fragment>
                                    {title && <S.Title data-test-id="title">{title}</S.Title>}
                                </React.Fragment>

                                <React.Fragment>
                                    {subtitle && (
                                        <S.Subtitle data-test-id="subtitle">{subtitle}</S.Subtitle>
                                    )}
                                </React.Fragment>
                            </S.Section>
                        </Carousel>
                    </S.SectionCarousel>
                )}
            </React.Fragment>
        </S.Header>
    );
}

Header.propTypes = {
    cartItems: PropTypes.array,
    destinations: PropTypes.array,
    forceCarousel: PropTypes.bool,
    forceSimplify: PropTypes.bool,
    forceSimplifyMobile: PropTypes.bool,
    images: PropTypes.array,
    navStatic: PropTypes.bool,
    onSearchSubmit: PropTypes.func,
    onSelectSearchDate: PropTypes.func,
    onSelectSearchDestination: PropTypes.func,
    openNavigation: PropTypes.func,
    searchDateFrom: PropTypes.instanceOf(Date),
    searchDateTo: PropTypes.instanceOf(Date),
    searchDestination: PropTypes.object,
    searchDestinationCategory: PropTypes.object,
    subtitle: PropTypes.node,
    title: PropTypes.node,
    wishList: PropTypes.array,
    checkoutPosition: PropTypes.number,
};

Header.defaultProps = {
    forceCarousel: false,
    forceSimplify: false,
    forceSimplifyMobile: false,
    navStatic: false,
};
export default React.memo(Header);
